import { render, staticRenderFns } from "./ManageUsersPage.vue?vue&type=template&id=238e9b28&scoped=true&"
import script from "./ManageUsersPage.vue?vue&type=script&lang=js&"
export * from "./ManageUsersPage.vue?vue&type=script&lang=js&"
import style0 from "./ManageUsersPage.vue?vue&type=style&index=0&id=238e9b28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238e9b28",
  null
  
)

export default component.exports